/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */
import { hasToken } from '../../../../utils';
import { useFormContext } from 'react-hook-form';
import { EpCard } from '../../../../components/EpCard';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import { notificationService } from '../../../../services/notificationService';
import { useHospitalStore } from '../../../../stores';
import styles from '../../../../templates/EpIncidentSteps/EpIncidentSteps.module.scss';
import { showAlertToasterByStatusMessage } from '../../../EpAlertToaster';
import { EpIcon } from '../../../EpIcon';
interface EpPatientDataProps {
  medicalRecord: string;
  identificationType: string;
  translations: string[];
}
// interface IPatientData {
//   patientName: string
//   birthDate: string
//   gender: string
//   hospitalAdmissionId: string
//   unitAdmissionId: string
//   age: string
// }

export const EpPatientData = ({
  medicalRecord,
  identificationType,
  translations,
}: EpPatientDataProps) => {
  const { setValue } = useFormContext();
  const { hospitalInfo } = useHospitalStore();

  const { getPatientData } = notificationService;
  const { data: patientData, isLoading }: { data: any; isLoading: boolean } =
    getPatientData(
      medicalRecord,
      identificationType,
      hospitalInfo?.HospitalId as string,
    );

  if (isLoading) {
    setValue('isLoadingMedicalRecord', isLoading);

    return null;
  }

  if (
    !isLoading &&
    (!patientData ||
      patientData?.unitAdmissionId === '00000000-0000-0000-0000-000000000000')
  ) {
    setValue('isLoadingMedicalRecord', isLoading);

    showAlertToasterByStatusMessage({
      response: {
        status: 1,
        message: t(translations, 'No attendance number was found.'),
      },
      alertToasterTitle: t(translations, 'Attention!'),
      alertToasterShouldShowSuccess: true,
    });

    return null;
  }

  if (!isLoading && !!patientData) {
    setValue('isLoadingMedicalRecord', isLoading);
    setValue('notificationRefersToId', {
      isValid: true,
      inputValue: patientData?.medicalRecord,
    });
    setValue(
      'documentNumber',
      hospitalInfo?.CultureCode === 'es-CL' ? medicalRecord : null,
    );

    setValue('patientIdentification', patientData?.medicalRecord);
    setValue('patientName', patientData?.patientName);
    setValue('genderId.inputLabel', patientData?.gender);
    setValue('genderId.inputValue', patientData?.genderCode?.toString());
    setValue('patientBirthDate', patientData?.birthDate);
    setValue('patientAge', patientData?.age);
    setValue('hospitalCare', patientData?.medicalRecord);
    setValue('hospitalAdmissionId', patientData?.hospitalAdmissionId);
    setValue('unitAdmissionId', patientData?.unitAdmissionId);

    return (
      <>
        <div className={styles['ep-patient-data']}>
          <EpCard
            cardId="ep-card-default"
            cardElevation="one"
            cardBodyContentWidthType="contained"
            cardHeaderIconName=""
            cardHeight="self"
            cardSpace="lg"
            cardWidth="auto"
          >
            <div slot="card-body-content">
              <h5>{t(translations, 'Selected patient')}</h5>
              <div className={styles['grid']}>
                <div className={styles['item']}>
                  <EpIcon iconName="SolidUser" iconSize={40} />
                  <div className={styles['field-box']}>
                    <span className={styles['field-data']}>
                      {patientData?.patientName}
                    </span>
                    <span className={styles['caption']}>
                      {t(translations, 'Name')}
                    </span>
                  </div>
                </div>
                <div className={styles['item']}>
                  <EpIcon iconName="RegularCalendarAlt" iconSize={40} />
                  <div className={styles['field-box']}>
                    <span className={styles['field-data']}>
                      {hasToken()
                        ? new Date(patientData?.birthDate).toLocaleDateString()
                        : patientData?.birthDate}
                    </span>
                    <span className={styles['caption']}>
                      {t(translations, 'Birth date:')}
                    </span>
                  </div>
                </div>

                <div className={styles['item']}>
                  <EpIcon iconName="SolidTransgender" iconSize={40} />
                  <div className={styles['field-box']}>
                    <span className={styles['field-data']}>
                      {patientData?.gender}
                    </span>
                    <span className={styles['caption']}>
                      {t(translations, 'Gender')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </EpCard>
        </div>
      </>
    );
  }

  return null;
};
